<template>
  <div>
    <div class="headerImg"></div>
    <div class="backIndex">
      <el-button type="primary" style="margin-left: 50px;" @click="$router.push('/')">返回首页</el-button>
    </div>
    <div class="main">
      <div class="center-t">
        <div class="sp-odt-brandorg">浙江省商标代理机构清单</div>
      </div>
      <div style="padding-left:30px;color:rgb(12 0 255)">点击从业人员数量可查看机构从业人员信息</div>

      <div class="page-wrap">
        <el-form :model="queryParams" ref="queryParamsRef" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="机构名称" prop="agencyName">
              <el-input v-model="queryParams.agencyName" placeholder="请输入机构名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址" prop="address">
              <el-input v-model="queryParams.address" placeholder="请输入地址" clearable />
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;">
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" width="55" label="序号" align="center">
            <template
              slot-scope="scope"
            >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="agencyName" label="机构名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="unifiedSocialCreditCode"
            label="统一社会信用代码"
            align="center"
            show-overflow-tooltip
            width="190"
          ></el-table-column>
          <el-table-column prop="address" label="地址" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="enterpriseType"
            label="企业类型"
            align="center"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="practitionerCount"
            label="从业人员"
            width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                style="color: rgb(12 0 255);cursor: pointer;"
                @click="openDialog(scope.row.unifiedSocialCreditCode)"
              >{{ scope.row.practitionerCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="applicationDate"
            label="申请日期"
            width="100"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="principal"
            label="负责人"
            width="80"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="phone" label="电话" width="130" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
      <employDialog
        :employ_dialogVisible.sync="employ_dialogVisible"
        v-if="employ_dialogVisible"
        :unifiedSocialCreditCode="unifiedSocialCreditCode"
      ></employDialog>
    </div>
  </div>
</template>
    <script>
import { getAgentorgList } from "@/api/index";
import employDialog from "./employDialog.vue";
export default {
  components: {
    employDialog
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1,
        agencyName: "",
        address: "",
      },
      tableData: [],
      id: "",
      total: 0,
      employ_dialogVisible: false,
      unifiedSocialCreditCode: ""
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getAgentorgList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    openDialog(unifiedSocialCreditCode) {
      this.unifiedSocialCreditCode = unifiedSocialCreditCode;
      this.employ_dialogVisible = true;
    },
    resetForm(){
        this.$refs.queryParamsRef.resetFields();
        this.getList()
    }
  }
};
</script>
    <style lang="less" scoped>
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  margin: 0px auto;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 20px;
}
.headerImg {
    width: 100%;
    height: 180px;
    min-width: 1200px;
    background-image: url("../../assets/brandhead.png");
    background-size: 100% 100%;
}
.backIndex {
  width: 1200px;
  margin: 10px auto;
}
</style>